import { FC, Fragment } from 'react';
import { Flex, Text } from '@servicetitan/anvil2';

import { LocationDetailModel } from '../../../models/location.model';
import { MessageCard } from '../../message-card/message-card';
import { ContactInfo } from '../customer-info/contact-info';

interface LocationDetailProps {
    data: LocationDetailModel;
}

export const LocationDetail: FC<LocationDetailProps> = ({ data }) => {
    return (
        <Fragment>
            <ContactInfo className="m-b-2" data={data.customer_contact_info} />

            <MessageCard flexDirection="column">
                <Text variant="headline" el="h3" size="small">
                    Location Metrics
                </Text>

                <Flex gap="2" className="m-b-half" justifyContent="space-between">
                    <Text size="small" subdued>
                        Installed Equipment Count
                    </Text>
                    <Text size="small">
                        <b>{data.installed_equipment_count}</b>
                    </Text>
                </Flex>

                <Flex gap="2" className="m-b-half" justifyContent="space-between">
                    <Text size="small">Completed Job Count</Text>
                    <Text size="small" subdued>
                        {data.completed_job_count}
                    </Text>
                </Flex>

                <Flex gap="2" className="m-b-half" justifyContent="space-between">
                    <Text size="small" subdued>
                        Active Memberships
                    </Text>
                    <Text size="small">
                        <b>{data.active_memberships}</b>
                    </Text>
                </Flex>

                <Flex gap="2" className="m-b-half" justifyContent="space-between">
                    <Text size="small" subdued>
                        Active Service Agreements
                    </Text>
                    <Text size="small">
                        <b>{data.active_service_agreements}</b>
                    </Text>
                </Flex>

                <Flex gap="2" justifyContent="space-between">
                    <Text size="small" subdued>
                        Open Estimates
                    </Text>
                    <Text size="small">
                        <b>{data.open_estimates}</b>
                    </Text>
                </Flex>
            </MessageCard>
        </Fragment>
    );
};
